import { forwardRef } from 'react';
import Tooltip from 'Components/Molecules/Tooltip/Tooltip';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

const BADGE_MAX_LENGTH = 10;

const Badge = forwardRef(({ children, ...props }, ref) => (
    <span
        ref={ref}
        {...props}
        className="text-2xs font-medium text-gray-700 bg-gray-100 rounded px-1.5 py-[1px] truncate pointer-events-auto"
    >
        {children}
    </span>
));

Badge.displayName = 'Badge';

Badge.propTypes = {
    children: PropTypes.node.isRequired,
};

function TaxBadge({ name }) {
    if (name.length > BADGE_MAX_LENGTH) {
        return (
            <Tooltip label={name}>
                <Badge>{name}</Badge>
            </Tooltip>
        );
    }

    return <Badge>{name}</Badge>;
}

TaxBadge.propTypes = {
    name: PropTypes.string.isRequired,
};

export default function MultiselectInvoiceTaxesValue({ taxIds, allTaxes, className }) {
    const selectedTaxes = allTaxes.filter((tax) => taxIds.includes(tax.id));

    if (selectedTaxes.length === 0) return null;

    return (
        <div className={cn('grid gap-0.5 pt-0.5 pointer-events-none', className)}>
            {selectedTaxes.map((tax) => (
                <div key={tax.id} className="flex min-w-0">
                    <TaxBadge name={tax.name} />
                </div>
            ))}
        </div>
    );
}

MultiselectInvoiceTaxesValue.propTypes = {
    taxIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    allTaxes: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        }),
    ).isRequired,
    className: PropTypes.string,
};
